import { jsx as _jsx } from "react/jsx-runtime";
import { UniversalService } from '@alliance-disposal/transport-types';
const UniversalServicesStatusPill = ({ status }) => {
    const getColor = (status) => {
        if (status === 'MIXED') {
            return `bg-statuses-MIXED-primary text-statuses-MIXED-text`;
        }
        if (status === 'CANCELLED') {
            return `bg-statuses-CANCELLED-primary text-statuses-CANCELLED-text`;
        }
        return `bg-statuses-${status}-primary text-statuses-${status}-text`;
    };
    const getLabel = (status) => {
        if (status === 'CANCELLED') {
            return 'Cancelled';
        }
        if (status === 'MIXED') {
            return 'Mixed';
        }
        return UniversalService.ServiceOrderStatusLabels[status];
    };
    return (_jsx("div", { className: `inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs ${getColor(status)}`, children: getLabel(status) }));
};
export default UniversalServicesStatusPill;
//# sourceMappingURL=UniversalServicesStatusPill.js.map